import * as React from "react";

export const RowRender = (props) => {
  const currentPeriod = props.currentPeriod || { period: 0 };
  const available = props.originalProps.dataItem.period === currentPeriod.period;
  
  const trProps = {
    ...props.tr.props,
    style: available && props.component === "Transaction" 
      ? { color: "#0b1dc9", backgroundColor: "lightcyan", height: 50 }
      : { backgroundColor: "none", height: 40 },
  };
  
  return React.cloneElement(props.tr, { ...trProps }, props.tr.props.children);
};
